// extracted by mini-css-extract-plugin
export default {"tabPanel":"BillAdministration_tabPanel__8yJ-d","tab":"BillAdministration_tab__K2okj"};